<script setup lang="ts">
import { PopupType, usePopupNotifications } from "@/composables";
import { whenRefAvailable } from "@/utilities";

const PopupAccountCreated = defineAsyncComponent(() => import("./AccountCreated.vue"));
const ItemCreated = defineAsyncComponent(() => import("./ItemCreated.vue"));
const EmailNotVerified = defineAsyncComponent(() => import("./EmailNotVerified.vue"));
const EmailVerificationResent = defineAsyncComponent(() => import("./EmailVerificationResent.vue"));
const HavingOldMarketplaceItems = defineAsyncComponent(() => import("./HavingOldMarketplaceItems.vue"));

const { toShowList, markClosed } = usePopupNotifications();
watch(
  () => toShowList.value.size,
  () => toShowList.value.forEach(openPopup)
);

const accountCreatedPopup = useTemplateRef<InstanceType<typeof PopupAccountCreated> | null>("accountCreatedPopup");
const ItemCreatedPopup = useTemplateRef<InstanceType<typeof PopupAccountCreated> | null>("itemCreatedPopup");
const EmailNotVerifiedPopup = useTemplateRef<InstanceType<typeof PopupAccountCreated> | null>("emailNotVerifiedPopup");
const EmailVerificationResentPopup = useTemplateRef<InstanceType<typeof PopupAccountCreated> | null>("emailVerificationResentPopup");
const havingOldMarketplaceItems = useTemplateRef<InstanceType<typeof PopupAccountCreated> | null>("havingOldMarketplaceItemsPopup");

const openPopup = (type: PopupType): void => {
  const type2ComponentMap = {
    [PopupType.AccountCreated]: accountCreatedPopup,
    [PopupType.ItemCreated]: ItemCreatedPopup,
    [PopupType.EmailNotVerified]: EmailNotVerifiedPopup,
    [PopupType.EmailVerificationResent]: EmailVerificationResentPopup,
    [PopupType.HavingOldMarketplaceItems]: havingOldMarketplaceItems,
  };
  const component = type2ComponentMap[type];
  whenRefAvailable(component).then((d) => d.value.open());
};
</script>

<template>
  <PopupAccountCreated v-if="toShowList.has(PopupType.AccountCreated)" ref="accountCreatedPopup" @close="markClosed(PopupType.AccountCreated)" />
  <ItemCreated v-if="toShowList.has(PopupType.ItemCreated)" ref="itemCreatedPopup" @close="markClosed(PopupType.ItemCreated)" />
  <EmailNotVerified v-if="toShowList.has(PopupType.EmailNotVerified)" ref="emailNotVerifiedPopup" @close="markClosed(PopupType.EmailNotVerified)" />
  <EmailVerificationResent v-if="toShowList.has(PopupType.EmailVerificationResent)" ref="emailVerificationResentPopup" @close="markClosed(PopupType.EmailVerificationResent)" />
  <HavingOldMarketplaceItems v-if="toShowList.has(PopupType.HavingOldMarketplaceItems)" ref="havingOldMarketplaceItemsPopup" @close="markClosed(PopupType.HavingOldMarketplaceItems)" />
</template>
